<template>
  <div class="flex gap-2">
    <el-dropdown @command="handleFirstChange">
      <div class="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded cursor-pointer hover:bg-gray-200">
        <img
          :src="chartIcon1"
          alt=""
          class="w-4 h-4"
        />
        <span class="text-sm">{{ firstSelected.name }}</span>
        <i class="el-icon-arrow-down text-xs"></i>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="item in list"
            :key="item.id"
            :command="item"
            :disabled="item.id === secondSelected.id"
          >
            {{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <el-dropdown @command="handleSecondChange">
      <div class="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded cursor-pointer hover:bg-gray-200">
        <img
          :src="chartIcon2"
          alt=""
          class="w-4 h-4"
        />
        <span class="text-sm">{{ secondSelected.name }}</span>
        <i class="el-icon-arrow-down text-xs"></i>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="item in list"
            :key="item.id"
            :command="item"
            :disabled="item.id === firstSelected.id"
          >
            {{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>
</style>

<script>
import { chartSelectList } from '../index';
export default {
  name: 'ChartSelect',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => chartSelectList,
    },
  },
  data() {
    return {
      chartIcon1: require('@/assets/icon/chart1.png'),
      chartIcon2: require('@/assets/icon/chart2.png'),
    };
  },
  computed: {
    firstSelected() {
      return this.list.find((item) => item.id === this.value[0]) || this.list[0];
    },
    secondSelected() {
      return this.list.find((item) => item.id === this.value[1]) || this.list[1];
    },
  },
  methods: {
    handleFirstChange(item) {
      this.$emit('input', [item.id, this.value[1]]);
    },
    handleSecondChange(item) {
      this.$emit('input', [this.value[0], item.id]);
    },
  },
};
</script>
